import { FormControlLabel, withStyles } from "@material-ui/core";

const FormControlLabelRightAlign = withStyles({
  root: {
    display: 'flex',
    justifyContent: 'end'
  }
})(FormControlLabel)

export default FormControlLabelRightAlign